import axios from 'axios';

import { ApiCore } from '../_utilities/core';

const auth = new ApiCore({
  url: '/auth/tokens',
});

const baseURL = process.env.REACT_APP_API_URL?.replace(/\/+$/, '') || '';

export default {
  createToken: ({ username, password }) => auth.create({ username, password }),
  deleteToken: () => auth.delete(),
  updateToken: (refreshToken) => auth.update({ refreshToken }),
  updateTokenWithoutAuth: (refreshToken) =>
    axios
      .put(
        `${baseURL}/auth/tokens`,
        { refreshToken },
        { headers: { 'Content-Type': 'application/json' } }
      )
      .then((res) => res.data),
  confirmGdprConsent: () =>
    new ApiCore({
      url: '/auth/users/settings/gdpr-consent',
    }).create(),
  getVehicleCostCenter: (code) => (queryString) =>
    new ApiCore({
      url: '/auth/system-settings/:code/values',
    })
      .query({ queryString, urlParams: { code } })
      .read(),
};
